// import React, { useState } from "react";
// import {
//   Grid,
//   Paper,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   alpha,
//   useTheme,
//   Fade,
//   Slide,
//   Chip,
//   Tabs,
//   Tab,
//   AppBar,
//   useMediaQuery
// } from "@mui/material";
// import {
//   Home as HomeIcon,
//   Work as WorkIcon,
//   Schedule as ScheduleIcon,
//   Security as SecurityIcon,
//   Star as StarIcon,
//   CleaningServices as CleaningServicesIcon,
//   Payment as PaymentIcon,
//   SupportAgent as SupportIcon,
//   Groups as GroupsIcon,
//   TrendingUp as TrendingUpIcon,
//   ArrowForward as ArrowForwardIcon,
//   CheckCircle as CheckCircleIcon,
//   AccountBalanceWallet as WalletIcon,
//   LocalOffer as LocalOfferIcon,
//   Person as PersonIcon
// } from "@mui/icons-material";
// import { keyframes } from "@mui/system";

// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-10px); }
// `;

// const gradientAnimation = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const [activeTab, setActiveTab] = useState(0);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   // Services for homeowners
//   const services = [
//     {
//       name: "Standard Cleaning",
//       price: "$120",
//       duration: "3-4 hours",
//       features: ["Dusting & vacuuming", "Kitchen & bathroom cleaning", "Floor mopping", "Surface wiping"]
//     },
//     {
//       name: "Deep Cleaning",
//       price: "$250",
//       duration: "5-6 hours",
//       features: ["Detailed dusting", "Appliance cleaning", "Grout scrubbing", "Inside cabinets"]
//     },
//     {
//       name: "Move In/Out Cleaning",
//       price: "$350",
//       duration: "6-8 hours",
//       features: ["Complete deep clean", "Inside appliances", "Window cleaning", "Wall wiping"]
//     }
//   ];

//   // Benefits for homeowners
//   const homeownerBenefits = [
//     {
//       icon: <SecurityIcon sx={{ fontSize: 40 }} />,
//       title: "Vetted Professionals",
//       description: "All cleaners are background-checked and thoroughly vetted"
//     },
//     {
//       icon: <PaymentIcon sx={{ fontSize: 40 }} />,
//       title: "Hassle-Free Payment",
//       description: "Secure online payment with satisfaction guarantee"
//     },
//     {
//       icon: <SupportIcon sx={{ fontSize: 40 }} />,
//       title: "24/7 Support",
//       description: "Round-the-clock customer support for any issues"
//     },
//     {
//       icon: <ScheduleIcon sx={{ fontSize: 40 }} />,
//       title: "Flexible Scheduling",
//       description: "Book at your convenience with easy rescheduling"
//     }
//   ];

//   // Benefits for cleaners
//   const cleanerBenefits = [
//     {
//       icon: <WalletIcon sx={{ fontSize: 40 }} />,
//       title: "Weekly Payments",
//       description: "Get paid every week via direct deposit, no waiting"
//     },
//     {
//       icon: <ScheduleIcon sx={{ fontSize: 40 }} />,
//       title: "Flexible Schedule",
//       description: "Choose your own hours and work when you want"
//     },
//     {
//       icon: <GroupsIcon sx={{ fontSize: 40 }} />,
//       title: "Steady Work",
//       description: "Consistent bookings in your preferred areas"
//     },
//     {
//       icon: <SupportIcon sx={{ fontSize: 40 }} />,
//       title: "Full Support",
//       description: "24/7 support team and cleaning supplies provided"
//     }
//   ];

//   // Earnings for cleaners
//   const earnings = [
//     { type: "Standard Cleaning", amount: "$25-35/hr", icon: <WorkIcon /> },
//     { type: "Deep Cleaning", amount: "$35-50/hr", icon: <TrendingUpIcon /> },
//     { type: "Commercial Cleaning", amount: "$30-45/hr", icon: <WalletIcon /> }
//   ];

//   const stats = [
//     { number: "50K+", label: "Happy Customers" },
//     { number: "500+", label: "Professional Cleaners" },
//     { number: "4.9/5", label: "Average Rating" },
//     { number: "200K+", label: "Cleanings Completed" }
//   ];

//   return (
//     <Box sx={{ overflow: "hidden" }}>
//       {/* Hero Section with Toggle */}
//       <Box
//         sx={{
//           background: activeTab === 0 
//             ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//             : "linear-gradient(135deg, #00b4db 0%, #0083b0 100%)",
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           position: "relative",
//           overflow: "hidden",
//           pt: 8
//         }}
//       >
//         {/* Animated Background */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: "radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%)",
//             animation: `${gradientAnimation} 15s ease infinite`,
//             backgroundSize: "400% 400%"
//           }}
//         />
        
//         <Container maxWidth="lg">
//           {/* Toggle Section */}
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Typography
//               variant="h3"
//               sx={{
//                 fontWeight: 800,
//                 color: "white",
//                 mb: 2
//               }}
//             >
//               FreshSweeper
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: "rgba(255, 255, 255, 0.9)",
//                 mb: 4
//               }}
//             >
//               The platform that connects homeowners with professional cleaners
//             </Typography>

//             <Card
//               sx={{
//                 maxWidth: 400,
//                 mx: "auto",
//                 background: "rgba(255, 255, 255, 0.1)",
//                 backdropFilter: "blur(10px)",
//                 borderRadius: "25px",
//                 border: "1px solid rgba(255, 255, 255, 0.2)"
//               }}
//             >
//               <AppBar position="static" sx={{ background: "transparent", boxShadow: "none", borderRadius: "25px" }}>
//                 <Tabs
//                   value={activeTab}
//                   onChange={handleTabChange}
//                   variant="fullWidth"
//                   sx={{
//                     "& .MuiTab-root": {
//                       color: "rgba(255, 255, 255, 0.7)",
//                       fontSize: "1rem",
//                       fontWeight: 600,
//                       py: 2
//                     },
//                     "& .Mui-selected": {
//                       color: "white !important"
//                     },
//                     "& .MuiTabs-indicator": {
//                       backgroundColor: "white",
//                       height: 3
//                     }
//                   }}
//                 >
//                   <Tab 
//                     icon={<HomeIcon sx={{ mb: 0.5 }} />} 
//                     iconPosition="start" 
//                     label="I Need Cleaning" 
//                   />
//                   <Tab 
//                     icon={<WorkIcon sx={{ mb: 0.5 }} />} 
//                     iconPosition="start" 
//                     label="I'm a Cleaner" 
//                   />
//                 </Tabs>
//               </AppBar>
//             </Card>
//           </Box>

//           {/* Dynamic Hero Content */}
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box>
//                   {activeTab === 0 ? (
//                     // Homeowner Content
//                     <>
//                       <Typography
//                         variant="h1"
//                         sx={{
//                           fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                           fontWeight: 800,
//                           color: "white",
//                           lineHeight: 1.1,
//                           mb: 2
//                         }}
//                       >
//                         Professional Cleaning
//                         <Box
//                           component="span"
//                           sx={{
//                             background: "linear-gradient(45deg, #FFD700 30%, #FFEC8B 90%)",
//                             backgroundClip: "text",
//                             WebkitBackgroundClip: "text",
//                             color: "transparent",
//                             display: "block"
//                           }}
//                         >
//                           For Your Home
//                         </Box>
//                       </Typography>
                      
//                       <Typography
//                         variant="h6"
//                         sx={{
//                           color: "rgba(255, 255, 255, 0.9)",
//                           mb: 4,
//                           fontSize: "1.2rem",
//                           lineHeight: 1.6
//                         }}
//                       >
//                         Book trusted, background-checked cleaners for a spotless home. 
//                         Flexible scheduling, transparent pricing, and satisfaction guaranteed.
//                       </Typography>

//                       <Button
//                         variant="contained"
//                         size="large"
//                         endIcon={<ArrowForwardIcon />}
//                         sx={{
//                           px: 4,
//                           py: 1.5,
//                           fontSize: "1.1rem",
//                           background: "linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)",
//                           borderRadius: "50px",
//                           boxShadow: "0 8px 32px rgba(255, 107, 107, 0.3)",
//                           "&:hover": {
//                             transform: "translateY(-2px)",
//                             boxShadow: "0 12px 40px rgba(255, 107, 107, 0.4)",
//                           }
//                         }}
//                       >
//                         Book Cleaning Now
//                       </Button>
//                     </>
//                   ) : (
//                     // Cleaner Content
//                     <>
//                       <Typography
//                         variant="h1"
//                         sx={{
//                           fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                           fontWeight: 800,
//                           color: "white",
//                           lineHeight: 1.1,
//                           mb: 2
//                         }}
//                       >
//                         Start Your Own
//                         <Box
//                           component="span"
//                           sx={{
//                             background: "linear-gradient(45deg, #FFD700 30%, #FFEC8B 90%)",
//                             backgroundClip: "text",
//                             WebkitBackgroundClip: "text",
//                             color: "transparent",
//                             display: "block"
//                           }}
//                         >
//                           Cleaning Business
//                         </Box>
//                       </Typography>
                      
//                       <Typography
//                         variant="h6"
//                         sx={{
//                           color: "rgba(255, 255, 255, 0.9)",
//                           mb: 4,
//                           fontSize: "1.2rem",
//                           lineHeight: 1.6
//                         }}
//                       >
//                         Earn up to $35/hour with flexible hours. We handle the bookings, 
//                         payments, and customer support while you focus on cleaning.
//                       </Typography>

//                       <Button
//                         variant="contained"
//                         size="large"
//                         endIcon={<ArrowForwardIcon />}
//                         sx={{
//                           px: 4,
//                           py: 1.5,
//                           fontSize: "1.1rem",
//                           background: "linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)",
//                           borderRadius: "50px",
//                           boxShadow: "0 8px 32px rgba(255, 107, 107, 0.3)",
//                           "&:hover": {
//                             transform: "translateY(-2px)",
//                             boxShadow: "0 12px 40px rgba(255, 107, 107, 0.4)",
//                           }
//                         }}
//                       >
//                         Apply as Cleaner
//                       </Button>
//                     </>
//                   )}
//                 </Box>
//               </Fade>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Slide in timeout={1000} direction="left">
//                 <Box
//                   sx={{
//                     position: "relative",
//                     animation: `${floatAnimation} 6s ease-in-out infinite`
//                   }}
//                 >
//                   {activeTab === 0 ? (
//                     // Homeowner Card
//                     <Card
//                       sx={{
//                         background: "rgba(255, 255, 255, 0.1)",
//                         backdropFilter: "blur(10px)",
//                         borderRadius: "20px",
//                         p: 4,
//                         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
//                         border: "1px solid rgba(255, 255, 255, 0.2)"
//                       }}
//                     >
//                       <Typography variant="h5" sx={{ color: "white", mb: 3, fontWeight: 600 }}>
//                         Quick Booking
//                       </Typography>
                      
//                       <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//                         <Button
//                           variant="contained"
//                           startIcon={<HomeIcon />}
//                           sx={{
//                             py: 1.5,
//                             background: "rgba(255, 255, 255, 0.2)",
//                             "&:hover": { background: "rgba(255, 255, 255, 0.3)" }
//                           }}
//                         >
//                           Select Service Type
//                         </Button>
                        
//                         <Button
//                           variant="contained"
//                           startIcon={<ScheduleIcon />}
//                           sx={{
//                             py: 1.5,
//                             background: "rgba(255, 255, 255, 0.2)",
//                             "&:hover": { background: "rgba(255, 255, 255, 0.3)" }
//                           }}
//                         >
//                           Choose Date & Time
//                         </Button>
                        
//                         <Button
//                           variant="contained"
//                           startIcon={<PaymentIcon />}
//                           sx={{
//                             py: 1.5,
//                             background: "linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)",
//                           }}
//                         >
//                           Confirm Booking
//                         </Button>
//                       </Box>
//                     </Card>
//                   ) : (
//                     // Cleaner Card
//                     <Card
//                       sx={{
//                         background: "rgba(255, 255, 255, 0.1)",
//                         backdropFilter: "blur(10px)",
//                         borderRadius: "20px",
//                         p: 4,
//                         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
//                         border: "1px solid rgba(255, 255, 255, 0.2)"
//                       }}
//                     >
//                       <Typography variant="h5" sx={{ color: "white", mb: 3, fontWeight: 600, textAlign: "center" }}>
//                         Potential Earnings
//                       </Typography>
                      
//                       <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
//                         {earnings.map((earning, index) => (
//                           <Box key={index} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   width: 40,
//                                   height: 40,
//                                   borderRadius: "10px",
//                                   background: "rgba(255, 255, 255, 0.2)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   color: "white"
//                                 }}
//                               >
//                                 {earning.icon}
//                               </Box>
//                               <Typography variant="body1" sx={{ color: "white", fontWeight: 500 }}>
//                                 {earning.type}
//                               </Typography>
//                             </Box>
//                             <Typography variant="h6" sx={{ color: "#FFD700", fontWeight: "bold" }}>
//                               {earning.amount}
//                             </Typography>
//                           </Box>
//                         ))}
//                       </Box>
//                     </Card>
//                   )}
//                 </Box>
//               </Slide>
//             </Grid>
//           </Grid>

//           {/* Stats Section */}
//           <Box sx={{ mt: 8, textAlign: "center" }}>
//             <Grid container spacing={4}>
//               {stats.map((stat, index) => (
//                 <Grid item xs={6} md={3} key={index}>
//                   <Box>
//                     <Typography variant="h3" fontWeight="bold" color="white">
//                       {stat.number}
//                     </Typography>
//                     <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.8)" }}>
//                       {stat.label}
//                     </Typography>
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>
//         </Container>
//       </Box>

//       {/* Services/Benefits Section */}
//       <Box sx={{ py: 12, background: "#f8f9ff" }}>
//         <Container maxWidth="lg">
//           {activeTab === 0 ? (
//             // Homeowner Services
//             <>
//               <Box sx={{ textAlign: "center", mb: 8 }}>
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 800,
//                     background: "linear-gradient(45deg, #667eea 30%, #764ba2 90%)",
//                     backgroundClip: "text",
//                     WebkitBackgroundClip: "text",
//                     color: "transparent",
//                     mb: 2
//                   }}
//                 >
//                   Our Cleaning Services
//                 </Typography>
//                 <Typography variant="h6" sx={{ color: "text.secondary" }}>
//                   Choose the perfect cleaning package for your home
//                 </Typography>
//               </Box>

//               <Grid container spacing={4}>
//                 {services.map((service, index) => (
//                   <Grid item xs={12} md={4} key={index}>
//                     <Card
//                       sx={{
//                         height: "100%",
//                         background: "white",
//                         borderRadius: "20px",
//                         boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-10px)",
//                           boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
//                         }
//                       }}
//                     >
//                       <CardContent sx={{ p: 4 }}>
//                         <Typography variant="h5" fontWeight="bold" gutterBottom>
//                           {service.name}
//                         </Typography>
                        
//                         <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 2 }}>
//                           <Typography variant="h4" fontWeight="bold" color="primary">
//                             {service.price}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             • {service.duration}
//                           </Typography>
//                         </Box>

//                         <Box sx={{ mb: 3 }}>
//                           {service.features.map((feature, idx) => (
//                             <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//                               <CheckCircleIcon color="primary" fontSize="small" />
//                               <Typography variant="body2">{feature}</Typography>
//                             </Box>
//                           ))}
//                         </Box>

//                         <Button
//                           variant="contained"
//                           fullWidth
//                           sx={{ borderRadius: "10px", py: 1.5 }}
//                         >
//                           Book This Service
//                         </Button>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           ) : (
//             // Cleaner Benefits
//             <>
//               <Box sx={{ textAlign: "center", mb: 8 }}>
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 800,
//                     background: "linear-gradient(45deg, #00b4db 30%, #0083b0 90%)",
//                     backgroundClip: "text",
//                     WebkitBackgroundClip: "text",
//                     color: "transparent",
//                     mb: 2
//                   }}
//                 >
//                   Why Clean With Us?
//                 </Typography>
//                 <Typography variant="h6" sx={{ color: "text.secondary" }}>
//                   Everything you need to build a successful cleaning business
//                 </Typography>
//               </Box>

//               <Grid container spacing={4}>
//                 {cleanerBenefits.map((benefit, index) => (
//                   <Grid item xs={12} sm={6} md={3} key={index}>
//                     <Card
//                       sx={{
//                         height: "100%",
//                         background: "white",
//                         borderRadius: "20px",
//                         boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-5px)",
//                           boxShadow: "0 15px 50px rgba(0, 0, 0, 0.15)",
//                         }
//                       }}
//                     >
//                       <CardContent sx={{ p: 4, textAlign: "center" }}>
//                         <Box
//                           sx={{
//                             width: 80,
//                             height: 80,
//                             borderRadius: "50%",
//                             background: "linear-gradient(135deg, #00b4db 0%, #0083b0 100%)",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             margin: "0 auto 24px",
//                             color: "white"
//                           }}
//                         >
//                           {benefit.icon}
//                         </Box>
//                         <Typography variant="h6" fontWeight="bold" gutterBottom>
//                           {benefit.title}
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           {benefit.description}
//                         </Typography>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}
//         </Container>
//       </Box>

//       {/* Benefits Section */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Typography
//                 variant="h2"
//                 sx={{
//                   fontWeight: 800,
//                   mb: 3,
//                   background: activeTab === 0 
//                     ? "linear-gradient(45deg, #667eea 30%, #764ba2 90%)"
//                     : "linear-gradient(45deg, #00b4db 30%, #0083b0 90%)",
//                   backgroundClip: "text",
//                   WebkitBackgroundClip: "text",
//                   color: "transparent"
//                 }}
//               >
//                 {activeTab === 0 ? "Why Homeowners Love Us" : "Start Earning in 3 Steps"}
//               </Typography>
              
//               <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
//                 {activeTab === 0 
//                   ? "We make home cleaning simple, reliable, and stress-free"
//                   : "Join our platform and start your cleaning business today"
//                 }
//               </Typography>

//               <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
//                 {(activeTab === 0 ? homeownerBenefits : [
//                   {
//                     step: 1,
//                     title: "Apply Online",
//                     description: "Complete our simple application form (takes 10 minutes)"
//                   },
//                   {
//                     step: 2,
//                     title: "Get Approved",
//                     description: "Pass our background check and complete orientation"
//                   },
//                   {
//                     step: 3,
//                     title: "Start Cleaning",
//                     description: "Accept bookings and start earning immediately"
//                   }
//                 ]).map((item, index) => (
//                   <Box key={index} sx={{ display: "flex", gap: 3 }}>
//                     <Box
//                       sx={{
//                         width: 60,
//                         height: 60,
//                         borderRadius: "15px",
//                         background: activeTab === 0 
//                           ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                           : "linear-gradient(135deg, #00b4db 0%, #0083b0 100%)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         color: "white",
//                         flexShrink: 0
//                       }}
//                     >
//                       {activeTab === 0 ? item.icon : item.step}
//                     </Box>
//                     <Box>
//                       <Typography variant="h6" fontWeight="bold" gutterBottom>
//                         {activeTab === 0 ? item.title : item.title}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {activeTab === 0 ? item.description : item.description}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Card
//                 sx={{
//                   background: activeTab === 0 
//                     ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                     : "linear-gradient(135deg, #00b4db 0%, #0083b0 100%)",
//                   color: "white",
//                   borderRadius: "20px",
//                   p: 4,
//                   boxShadow: activeTab === 0 
//                     ? "0 20px 60px rgba(102, 126, 234, 0.3)"
//                     : "0 20px 60px rgba(0, 180, 219, 0.3)"
//                 }}
//               >
//                 <Typography variant="h5" fontWeight="bold" gutterBottom>
//                   {activeTab === 0 ? "Special Offer" : "Ready to Start?"}
//                 </Typography>
//                 {activeTab === 0 ? (
//                   <>
//                     <Typography variant="h3" fontWeight="bold" gutterBottom>
//                       20% OFF
//                     </Typography>
//                     <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
//                       Your first cleaning service. Limited time offer!
//                     </Typography>
//                     <Chip 
//                       label="Use code: WELCOME20" 
//                       sx={{ 
//                         background: "rgba(255,255,255,0.2)",
//                         color: "white",
//                         fontSize: "1rem",
//                         py: 2
//                       }}
//                     />
//                   </>
//                 ) : (
//                   <>
//                     <Typography variant="h4" fontWeight="bold" gutterBottom>
//                       $35/hr Average
//                     </Typography>
//                     <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
//                       Join our platform and start earning today with flexible hours and weekly payments.
//                     </Typography>
//                     <Button
//                       variant="contained"
//                       fullWidth
//                       sx={{
//                         background: "rgba(255,255,255,0.2)",
//                         "&:hover": { background: "rgba(255,255,255,0.3)" }
//                       }}
//                     >
//                       Start Your Application
//                     </Button>
//                   </>
//                 )}
//               </Card>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Unified CTA Section */}
//       <Box
//         sx={{
//           py: 12,
//           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           color: "white",
//           textAlign: "center"
//         }}
//       >
//         <Container maxWidth="md">
//           <Typography
//             variant="h3"
//             sx={{
//               fontWeight: 800,
//               mb: 3,
//               background: "linear-gradient(45deg, #fff 30%, #f0f0f0 90%)",
//               backgroundClip: "text",
//               WebkitBackgroundClip: "text",
//               color: "transparent"
//             }}
//           >
//             Ready to Get Started?
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 4,
//               opacity: 0.9,
//               fontSize: "1.2rem"
//             }}
//           >
//             Whether you need a clean home or want to earn as a professional cleaner, 
//             FreshSweeper has you covered.
//           </Typography>
//           <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
//             <Button
//               variant="contained"
//               size="large"
//               startIcon={<HomeIcon />}
//               onClick={() => setActiveTab(0)}
//               sx={{
//                 px: 4,
//                 py: 2,
//                 fontSize: "1.1rem",
//                 background: "linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)",
//                 borderRadius: "50px",
//               }}
//             >
//               Book a Cleaning
//             </Button>
//             <Button
//               variant="outlined"
//               size="large"
//               startIcon={<WorkIcon />}
//               onClick={() => setActiveTab(1)}
//               sx={{
//                 px: 4,
//                 py: 2,
//                 fontSize: "1.1rem",
//                 borderColor: "white",
//                 color: "white",
//                 borderRadius: "50px",
//               }}
//             >
//               Become a Cleaner
//             </Button>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;




import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  Card,
  CardContent,
  useTheme,
  Fade,
  Slide,
  Chip,
  AppBar,
  Stack,
  alpha,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton
} from "@mui/material";
import {
  Home as HomeIcon,
  Work as WorkIcon,
  Schedule as ScheduleIcon,
  Security as SecurityIcon,
  Star as StarIcon,
  CleaningServices as CleaningServicesIcon,
  Payment as PaymentIcon,
  SupportAgent as SupportIcon,
  Groups as GroupsIcon,
  ArrowForward as ArrowForwardIcon,
  CheckCircle as CheckCircleIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  Apartment as ApartmentIcon,
  Bathtub as BathroomIcon,
  Kitchen as KitchenIcon,
  Weekend as LivingRoomIcon,
  Yard as YardIcon,
  PhoneIphone as MobileIcon,
  QrCode2 as QRIcon,
  FormatQuote as QuoteIcon,
  Apple as AppleIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from "@mui/icons-material";
import { keyframes } from "@mui/system";

// Animations
const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-4px); }
`;

const pulseAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const slideAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

const Home = () => {
  const theme = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  // Property size based pricing
  const propertySizes = [
    {
      type: "Studio",
      bedrooms: 0,
      bathrooms: 1,
      price: "$79",
      description: "Perfect for studio apartments",
      features: ["1 Bathroom", "Kitchen", "Living Area", "Basic Cleaning"]
    },
    {
      type: "1-Bedroom",
      bedrooms: 1,
      bathrooms: 1,
      price: "$99",
      description: "Ideal for 1-bedroom listings",
      features: ["1 Bedroom", "1 Bathroom", "Kitchen", "Living Room", "Standard Cleaning"],
      popular: true
    },
    {
      type: "2-Bedroom",
      bedrooms: 2,
      bathrooms: 2,
      price: "$149",
      description: "Great for 2-bedroom properties",
      features: ["2 Bedrooms", "2 Bathrooms", "Kitchen", "Living Room", "Thorough Cleaning"]
    },
    {
      type: "3+ Bedroom",
      bedrooms: 3,
      bathrooms: 2,
      price: "$199+",
      description: "For larger properties",
      features: ["3+ Bedrooms", "2+ Bathrooms", "Large Kitchen", "Living Areas", "Premium Cleaning"]
    }
  ];

  // Extra services
  const extraServices = [
    {
      icon: <YardIcon />,
      name: "Lawn & Garden",
      price: "+$45",
      description: "Lawn mowing and garden maintenance"
    },
    {
      icon: <ApartmentIcon />,
      name: "Balcony/Patio",
      price: "+$35",
      description: "Outdoor area cleaning"
    },
    {
      icon: <KitchenIcon />,
      name: "Deep Kitchen",
      price: "+$25",
      description: "Oven, fridge, and cabinet cleaning"
    },
    {
      icon: <BathroomIcon />,
      name: "Bathroom Sanitizing",
      price: "+$20",
      description: "Extra bathroom deep clean"
    }
  ];

  // Features for Airbnb hosts
  const features = [
    {
      icon: <MobileIcon sx={{ fontSize: 32 }} />,
      title: "Mobile-First App",
      description: "Book and manage cleanings directly from your phone"
    },
    {
      icon: <ScheduleIcon sx={{ fontSize: 32 }} />,
      title: "Flexible Scheduling",
      description: "Sync with your Airbnb calendar for automatic bookings"
    },
    {
      icon: <PaymentIcon sx={{ fontSize: 32 }} />,
      title: "Instant Pricing",
      description: "Get accurate pricing based on your property size"
    },
    {
      icon: <SupportIcon sx={{ fontSize: 32 }} />,
      title: "24/7 Support",
      description: "Always available for last-minute bookings"
    }
  ];

  // How it works steps
  const steps = [
    {
      number: "1",
      icon: "📱",
      title: "Download Our App",
      description: "Get our mobile app from App Store or Google Play"
    },
    {
      number: "2",
      icon: "🏠",
      title: "Set Up Your Property",
      description: "Enter bedrooms, bathrooms, and extra services needed"
    },
    {
      number: "3",
      icon: "📅",
      title: "Sync Calendar",
      description: "Connect your Airbnb calendar for automatic cleaning requests"
    },
    {
      number: "4",
      icon: "✨",
      title: "Enjoy Clean Stays",
      description: "We handle cleaning after every guest checkout"
    }
  ];

  // Stats specific to Airbnb cleaning
  const stats = [
    { number: "5,000+", label: "Airbnb Listings" },
    { number: "4.9★", label: "Host Rating" },
    { number: "15min", label: "Avg. Booking Time" },
    { number: "98%", label: "On-Time Rate" }
  ];

  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Airbnb Superhost",
      location: "Miami, FL",
      rating: 5,
      comment: "FreshSweeper has completely transformed my hosting business. The app makes scheduling so easy, and my cleaner is always on time. My guests consistently mention how spotless the property is!",
      avatar: "SJ",
      properties: "3 Properties"
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Property Manager",
      location: "Austin, TX",
      rating: 5,
      comment: "Managing 12 Airbnb properties used to be a nightmare. With FreshSweeper, I can coordinate cleanings seamlessly. The property-based pricing is fair and transparent.",
      avatar: "MC",
      properties: "12 Properties"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      role: "Airbnb Host",
      location: "San Diego, CA",
      rating: 5,
      comment: "The mobile app is a game-changer! I get notified immediately after guests check out, and with one tap, I can schedule a cleaning. The quality is consistently excellent.",
      avatar: "ER",
      properties: "2 Properties"
    },
    {
      id: 4,
      name: "David Thompson",
      role: "Real Estate Investor",
      location: "Chicago, IL",
      rating: 5,
      comment: "As someone with multiple short-term rentals, reliability is everything. FreshSweeper has never let me down. The cleaners are professional and the app keeps everything organized.",
      avatar: "DT",
      properties: "7 Properties"
    },
    {
      id: 5,
      name: "Jennifer Martinez",
      role: "Airbnb Host",
      location: "Denver, CO",
      rating: 5,
      comment: "The pricing model is perfect - I only pay for what I need. No more overpaying for cleaning services that don't match my property size.",
      avatar: "JM",
      properties: "4 Properties"
    }
  ];

  // App features for mobile app section
  const appFeatures = [
    {
      icon: "📱",
      title: "Instant Booking",
      description: "Schedule cleanings in under 60 seconds"
    },
    {
      icon: "📅",
      title: "Calendar Sync",
      description: "Automatically syncs with your Airbnb calendar"
    },
    {
      icon: "💰",
      title: "Transparent Pricing",
      description: "See exactly what you'll pay before booking"
    },
    {
      icon: "⭐",
      title: "Cleaner Ratings",
      description: "Choose from our top-rated cleaning professionals"
    }
  ];

  const handleNextTestimonial = () => {
    setTestimonialIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevTestimonial = () => {
    setTestimonialIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleDotClick = (index) => {
    setTestimonialIndex(index);
  };

  return (
    <Box sx={{ overflow: "hidden", background: theme.palette.background.default }}>
      {/* Navigation */}
      

      {/* Hero Section */}
      <Box sx={{ pt: 12, pb: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Fade in timeout={800}>
                <Box>
                  <Chip 
                    label="🏠 Made for Airbnb Hosts" 
                    sx={{ 
                      mb: 3,
                      background: alpha(theme.palette.primary.main, 0.1),
                      color: theme.palette.primary.dark,
                      fontWeight: 600,
                      fontSize: "0.85rem"
                    }}
                  />
                  
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
                      fontWeight: 700,
                      color: theme.palette.text.primary,
                      lineHeight: 1.1,
                      mb: 2
                    }}
                  >
                    Airbnb Cleaning
                    <Box
                      component="span"
                      sx={{
                        color: theme.palette.primary.main,
                        display: "block"
                      }}
                    >
                      Made Simple
                    </Box>
                  </Typography>
                  
                  <Typography
                    variant="h6"
                    sx={{
                      color: theme.palette.text.secondary,
                      mb: 4,
                      fontSize: "1.1rem",
                      lineHeight: 1.6,
                      fontWeight: 400
                    }}
                  >
                    The mobile app that automatically schedules cleanings based on your property size. 
                    Perfect pricing for bedrooms, bathrooms, and extra services. Keep your Airbnb spotless with zero hassle.
                  </Typography>

                  <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 6 }}>
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<QRIcon />}
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        background: theme.palette.primary.main,
                        borderRadius: "8px",
                        boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
                        "&:hover": {
                          transform: "translateY(-1px)",
                          boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
                        },
                        transition: "all 0.3s ease"
                      }}
                    >
                      Scan to Download App
                    </Button>
                    
                    <Button
                      variant="outlined"
                      size="large"
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        borderColor: theme.palette.secondary.light,
                        color: theme.palette.text.primary,
                        borderRadius: "8px",
                      }}
                    >
                      View Pricing
                    </Button>
                  </Stack>

                  {/* Stats */}
                  <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                    {stats.map((stat, index) => (
                      <Box key={index}>
                        <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
                          {stat.number}
                        </Typography>
                        <Typography variant="body2" color={theme.palette.text.secondary} fontWeight="500">
                          {stat.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Fade>
            </Grid>

            <Grid item xs={12} md={6}>
              <Slide in timeout={1000} direction="left">
                <Box
                  sx={{
                    position: "relative",
                    animation: `${floatAnimation} 6s ease-in-out infinite`
                  }}
                >
                  <Card
                    sx={{
                      background: theme.palette.background.paper,
                      borderRadius: "12px",
                      p: 4,
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
                    }}
                  >
                    <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: theme.palette.text.primary }}>
                      Property-Based Pricing
                    </Typography>
                    
                    <Stack spacing={2}>
                      {[
                        { icon: "🛏️", text: "Bedrooms: $25 each" },
                        { icon: "🚿", text: "Bathrooms: $20 each" },
                        { icon: "🍳", text: "Kitchen: $15 included" },
                        { icon: "🛋️", text: "Living Room: $10 included" },
                        { icon: "🌿", text: "Lawn: +$45 (optional)" }
                      ].map((item, index) => (
                        <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: "8px",
                              background: alpha(theme.palette.primary.main, 0.1),
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: theme.palette.primary.main,
                              fontWeight: "bold",
                              fontSize: "1.1rem"
                            }}
                          >
                            {item.icon}
                          </Box>
                          <Typography variant="body1" color={theme.palette.text.primary} fontWeight="500">
                            {item.text}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>

                    <Box sx={{ textAlign: "center", mt: 3 }}>
                      <Chip 
                        label="No hidden fees • Instant quotes" 
                        sx={{ 
                          background: alpha(theme.palette.primary.main, 0.1),
                          color: theme.palette.primary.dark,
                          fontWeight: 500
                        }}
                      />
                    </Box>
                  </Card>
                </Box>
              </Slide>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Property Size Pricing */}
      <Box sx={{ py: 10, background: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: theme.palette.text.primary,
                mb: 2,
                fontSize: { xs: "2.25rem", md: "2.75rem" }
              }}
            >
              Property-Based Pricing
            </Typography>
            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto", fontSize: "1rem" }}>
              Fair pricing based on your actual property size. Pay only for what you need.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {propertySizes.map((property, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    background: theme.palette.background.paper,
                    borderRadius: "12px",
                    boxShadow: property.popular ? `0 8px 32px ${alpha(theme.palette.primary.main, 0.15)}` : "0 4px 20px rgba(0, 0, 0, 0.08)",
                    border: property.popular ? `2px solid ${theme.palette.primary.main}` : `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                    transition: "all 0.3s ease",
                    position: "relative",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: property.popular 
                        ? `0 12px 40px ${alpha(theme.palette.primary.main, 0.2)}` 
                        : "0 8px 32px rgba(0, 0, 0, 0.12)",
                    }
                  }}
                >
                  {property.popular && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: -12,
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        px: 3,
                        py: 0.5,
                        borderRadius: "16px",
                        fontSize: "0.8rem",
                        fontWeight: 600
                      }}
                    >
                      Most Popular
                    </Box>
                  )}
                  
                  <CardContent sx={{ p: 3, pt: property.popular ? 4 : 3 }}>
                    <Box sx={{ textAlign: "center", mb: 2 }}>
                      <Typography variant="h5" fontWeight="600" color={theme.palette.text.primary} gutterBottom>
                        {property.type}
                      </Typography>
                      <Typography variant="body2" color={theme.palette.text.secondary} sx={{ mb: 2 }}>
                        {property.description}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: 1, mb: 3 }}>
                      <Typography variant="h3" fontWeight="700" color={theme.palette.primary.main}>
                        {property.price}
                      </Typography>
                      <Typography variant="body2" color={theme.palette.text.secondary} fontWeight="500">
                        /cleaning
                      </Typography>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                      {property.features.map((feature, idx) => (
                        <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                          <CheckCircleIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
                          <Typography variant="body2" color={theme.palette.text.primary} fontWeight="500">
                            {feature}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    <Button
                      variant={property.popular ? "contained" : "outlined"}
                      fullWidth
                      sx={{
                        borderRadius: "8px",
                        py: 1,
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        ...(property.popular && {
                          background: theme.palette.primary.main,
                          boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`
                        }),
                        ...(!property.popular && {
                          borderColor: theme.palette.primary.main,
                          color: theme.palette.primary.main
                        })
                      }}
                    >
                      Select Plan
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Extra Services */}
      <Box sx={{ py: 10, background: theme.palette.background.default }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: theme.palette.text.primary,
                mb: 2,
                fontSize: { xs: "2.25rem", md: "2.75rem" }
              }}
            >
              Add Extra Services
            </Typography>
            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
              Customize your cleaning with additional services
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {extraServices.map((service, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    background: theme.palette.background.paper,
                    borderRadius: "12px",
                    p: 3,
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
                    }
                  }}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "12px",
                      background: alpha(theme.palette.primary.main, 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: theme.palette.primary.main,
                      margin: "0 auto 16px"
                    }}
                  >
                    {service.icon}
                  </Box>
                  <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary} gutterBottom>
                    {service.name}
                  </Typography>
                  <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main} gutterBottom>
                    {service.price}
                  </Typography>
                  <Typography variant="body2" color={theme.palette.text.secondary}>
                    {service.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* How It Works - Mobile App Focus */}
      <Box sx={{ py: 12, background: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: theme.palette.text.primary,
                mb: 2,
                fontSize: { xs: "2.25rem", md: "2.75rem" }
              }}
            >
              How It Works
            </Typography>
            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
              Everything happens right from your phone
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {steps.map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box sx={{ textAlign: "center" }}>
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "20px",
                      background: alpha(theme.palette.primary.main, 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: theme.palette.primary.main,
                      fontWeight: "bold",
                      fontSize: "2rem",
                      mx: "auto",
                      mb: 3,
                      animation: `${pulseAnimation} 2s ease-in-out infinite`
                    }}
                  >
                    {step.icon}
                  </Box>
                  <Typography variant="h5" fontWeight="600" gutterBottom>
                    {step.title}
                  </Typography>
                  <Typography variant="body2" color={theme.palette.text.secondary}>
                    {step.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Mobile App Showcase Section */}
      <Box sx={{ py: 12, background: theme.palette.background.default }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Fade in timeout={800}>
                <Box>
                  <Chip 
                    label="📱 Mobile App" 
                    sx={{ 
                      mb: 3,
                      background: alpha(theme.palette.primary.main, 0.1),
                      color: theme.palette.primary.dark,
                      fontWeight: 600,
                      fontSize: "0.85rem"
                    }}
                  />
                  
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.text.primary,
                      mb: 3,
                      fontSize: { xs: "2.25rem", md: "2.75rem" }
                    }}
                  >
                    Everything You Need in One App
                  </Typography>
                  
                  <Typography
                    variant="h6"
                    sx={{
                      color: theme.palette.text.secondary,
                      mb: 4,
                      fontSize: "1.1rem",
                      lineHeight: 1.6
                    }}
                  >
                    Manage all your Airbnb cleanings from the palm of your hand. 
                    Our mobile app gives you complete control over scheduling, 
                    pricing, and communication with your cleaning team.
                  </Typography>

                  <Grid container spacing={3} sx={{ mb: 4 }}>
                    {appFeatures.map((feature, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              borderRadius: "12px",
                              background: alpha(theme.palette.primary.main, 0.1),
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: theme.palette.primary.main,
                              fontWeight: "bold",
                              fontSize: "1.5rem",
                              flexShrink: 0
                            }}
                          >
                            {feature.icon}
                          </Box>
                          <Box>
                            <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary} gutterBottom>
                              {feature.title}
                            </Typography>
                            <Typography variant="body2" color={theme.palette.text.secondary}>
                              {feature.description}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>

                  <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                    <Button
                      variant="contained"
                      startIcon={<AppleIcon />}
                      sx={{
                        px: 3,
                        py: 1.5,
                        background: theme.palette.text.primary,
                        color: theme.palette.background.paper,
                        borderRadius: "8px",
                        fontWeight: 600,
                        "&:hover": {
                          background: theme.palette.text.primary,
                          transform: "translateY(-1px)",
                          boxShadow: `0 4px 12px ${alpha(theme.palette.text.primary, 0.3)}`
                        },
                        transition: "all 0.3s ease"
                      }}
                    >
                      Download on App Store
                    </Button>
                    
                    <Button
                      variant="outlined"
                      sx={{
                        px: 3,
                        py: 1.5,
                        borderColor: theme.palette.text.primary,
                        color: theme.palette.text.primary,
                        borderRadius: "8px",
                        fontWeight: 600,
                        "&:hover": {
                          background: alpha(theme.palette.text.primary, 0.05),
                          transform: "translateY(-1px)"
                        },
                        transition: "all 0.3s ease"
                      }}
                    >
                      Get on Google Play
                    </Button>
                  </Stack>
                </Box>
              </Fade>
            </Grid>

            <Grid item xs={12} md={6}>
              <Slide in timeout={1000} direction="left">
                <Box
                  sx={{
                    position: "relative",
                    animation: `${floatAnimation} 6s ease-in-out infinite`
                  }}
                >
                  <Card
                    sx={{
                      background: theme.palette.background.paper,
                      borderRadius: "20px",
                      p: 3,
                      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                      maxWidth: 300,
                      mx: "auto"
                    }}
                  >
                    {/* Mock phone screen */}
                    <Box
                      sx={{
                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                        borderRadius: "12px",
                        p: 3,
                        color: theme.palette.primary.contrastText,
                        textAlign: "center"
                      }}
                    >
                      <Typography variant="h6" fontWeight="700" gutterBottom>
                        FreshSweeper
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>
                        Airbnb Cleaning Made Simple
                      </Typography>
                      
                      <Box sx={{ background: 'rgba(255,255,255,0.2)', borderRadius: '8px', p: 2, mb: 2 }}>
                        <Typography variant="body2" fontWeight="600">
                          Next Cleaning: Today 2:00 PM
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          2 Bedroom • 2 Bathroom
                        </Typography>
                      </Box>
                      
                      <Stack spacing={1}>
                        {['Schedule Cleaning', 'View Calendar', 'Manage Properties', 'Settings'].map((item, index) => (
                          <Box 
                            key={index}
                            sx={{ 
                              background: 'rgba(255,255,255,0.1)', 
                              borderRadius: '6px', 
                              p: 1,
                              textAlign: 'center'
                            }}
                          >
                            <Typography variant="body2">{item}</Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  </Card>
                </Box>
              </Slide>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* UPDATED: Testimonials Section with Horizontal Slide */}
      <Box sx={{ py: 12, background: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip 
              label="❤️ Loved by Hosts" 
              sx={{ 
                mb: 3,
                background: alpha(theme.palette.secondary.main, 0.1),
                color: theme.palette.secondary.dark,
                fontWeight: 600,
                fontSize: "0.85rem"
              }}
            />
            
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: theme.palette.text.primary,
                mb: 2,
                fontSize: { xs: "2.25rem", md: "2.75rem" }
              }}
            >
              What Our Hosts Say
            </Typography>
            <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
              Join thousands of satisfied Airbnb hosts who trust FreshSweeper with their properties
            </Typography>
          </Box>

          {/* Testimonials Carousel */}
          <Box sx={{ position: 'relative', mb: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {/* Previous Button */}
              <IconButton
                onClick={handlePrevTestimonial}
                sx={{
                  position: 'absolute',
                  left: { xs: -10, md: -40 },
                  zIndex: 2,
                  background: theme.palette.background.paper,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  '&:hover': {
                    background: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                <ChevronLeftIcon />
              </IconButton>

              {/* Testimonial Card */}
              <Box sx={{ width: '100%', maxWidth: 800, mx: 'auto' }}>
                <Fade in key={testimonialIndex} timeout={500}>
                  <Card
                    sx={{
                      background: theme.palette.background.paper,
                      borderRadius: "16px",
                      p: 4,
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                      transition: "all 0.3s ease",
                      mx: 2
                    }}
                  >
                    <QuoteIcon 
                      sx={{ 
                        fontSize: 40, 
                        color: alpha(theme.palette.primary.main, 0.2),
                        mb: 2 
                      }} 
                    />
                    
                    <Box sx={{ display: "flex", mb: 2, justifyContent: 'center' }}>
                      {[...Array(5)].map((_, i) => (
                        <StarIcon 
                          key={i} 
                          sx={{ 
                            color: i < testimonials[testimonialIndex].rating ? theme.palette.secondary.main : theme.palette.grey[300],
                            fontSize: 24
                          }} 
                        />
                      ))}
                    </Box>
                    
                    <Typography 
                      variant="h6" 
                      sx={{ 
                        color: theme.palette.text.primary, 
                        mb: 3,
                        lineHeight: 1.6,
                        fontStyle: "italic",
                        textAlign: 'center',
                        fontSize: { xs: '1rem', md: '1.2rem' }
                      }}
                    >
                      "{testimonials[testimonialIndex].comment}"
                    </Typography>
                    
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center', gap: 2 }}>
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          borderRadius: "12px",
                          background: alpha(theme.palette.primary.main, 0.1),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: theme.palette.primary.main,
                          fontWeight: "bold",
                          fontSize: "1.2rem"
                        }}
                      >
                        {testimonials[testimonialIndex].avatar}
                      </Box>
                      
                      <Box sx={{ textAlign: 'left' }}>
                        <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary}>
                          {testimonials[testimonialIndex].name}
                        </Typography>
                        <Typography variant="body2" color={theme.palette.text.secondary}>
                          {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
                        </Typography>
                        <Typography variant="caption" color={theme.palette.text.secondary}>
                          {testimonials[testimonialIndex].location}
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Fade>
              </Box>

              {/* Next Button */}
              <IconButton
                onClick={handleNextTestimonial}
                sx={{
                  position: 'absolute',
                  right: { xs: -10, md: -40 },
                  zIndex: 2,
                  background: theme.palette.background.paper,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  '&:hover': {
                    background: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                <ChevronRightIcon />
              </IconButton>
            </Box>

            {/* Dot Indicators */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 4 }}>
              {testimonials.map((_, index) => (
                <Box
                  key={index}
                  onClick={() => handleDotClick(index)}
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    cursor: 'pointer',
                    background: index === testimonialIndex ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.3),
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: theme.palette.primary.main,
                      transform: 'scale(1.2)'
                    }
                  }}
                />
              ))}
            </Box>
          </Box>

          {/* Trust indicators */}
          <Box sx={{ textAlign: "center", mt: 8 }}>
            <Typography variant="body2" color={theme.palette.text.secondary} sx={{ mb: 2 }}>
              TRUSTED BY AIRBNB HOSTS WORLDWIDE
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 4, flexWrap: "wrap" }}>
              {[
                { number: "4.9/5", label: "App Store Rating" },
                { number: "10K+", label: "Active Users" },
                { number: "50K+", label: "Cleanings Completed" },
                { number: "99.8%", label: "Satisfaction Rate" }
              ].map((stat, index) => (
                <Box key={index} sx={{ textAlign: "center" }}>
                  <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
                    {stat.number}
                  </Typography>
                  <Typography variant="body2" color={theme.palette.text.secondary} fontWeight="500">
                    {stat.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Final CTA - Mobile App Download */}
      <Box sx={{ py: 12, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
        <Container maxWidth="md">
          <Box sx={{ textAlign: "center", color: theme.palette.primary.contrastText }}>
            <MobileIcon sx={{ fontSize: 60, mb: 3, opacity: 0.9 }} />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                mb: 3,
                fontSize: { xs: "2.25rem", md: "2.75rem" }
              }}
            >
              Ready to Simplify Your Airbnb Cleaning?
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                opacity: 0.9,
                fontSize: "1.1rem",
                maxWidth: "600px",
                mx: "auto"
              }}
            >
              Download our mobile app and get your first cleaning at 20% off. Perfect pricing based on your property size.
            </Typography>
            
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
              <Button
                variant="contained"
                size="large"
                startIcon={<QRIcon />}
                sx={{
                  px: 4,
                  py: 2,
                  fontSize: "1.1rem",
                  background: alpha(theme.palette.primary.contrastText, 0.2),
                  backdropFilter: "blur(10px)",
                  borderRadius: "8px",
                  border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.3)}`,
                  fontWeight: 600,
                  color: theme.palette.primary.contrastText,
                  "&:hover": {
                    background: alpha(theme.palette.primary.contrastText, 0.3),
                    transform: "translateY(-1px)"
                  },
                  transition: "all 0.3s ease"
                }}
              >
                Scan QR Code
              </Button>
              
              <Button
                variant="outlined"
                size="large"
                sx={{
                  px: 4,
                  py: 2,
                  fontSize: "1.1rem",
                  borderColor: theme.palette.primary.contrastText,
                  color: theme.palette.primary.contrastText,
                  borderRadius: "8px",
                  "&:hover": {
                    background: alpha(theme.palette.primary.contrastText, 0.1),
                  }
                }}
              >
                Send Download Link
              </Button>
            </Stack>
            
            <Typography variant="body2" sx={{ mt: 3, opacity: 0.8 }}>
              Available on iOS and Android
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;